<template>
  <div>
    <div :id="namespaceLivre">
      <b-col cols="12">
        <h2 :class="showDetails.livre ? 'rotate active' : 'no-rotate'">
          Vente par livre
          <i
            class="fas fa-chevron-left"
            @click="toggleLivre"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.livre"
        :id="'liste_stats_' + namespaceLivre"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableLivre"
          :name="namespaceLivre"
          :actions="getActions(namespaceLivre)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.livre"
          verbose-namespace="Vente par livre"
          @row-click="
            openDetails($event, namespaceLivre, 'libraire', 'vente par livre')
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableLivre,
              namespaceLivre,
              'libraire',
              'vente par livre'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespacePays">
      <b-col cols="12">
        <h2 :class="showDetails.pays ? 'rotate active' : 'no-rotate'">
          Vente par pays
          <i
            class="fas fa-chevron-left"
            @click="togglePays"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.pays"
        :id="'liste_stats_' + namespacePays"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTablePays"
          :name="namespacePays"
          :actions="getActions(namespacePays)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.pays"
          verbose-namespace="Vente par pays"
          @row-click="
            openDetails($event, namespacePays, 'libraire', 'vente par pays')
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTablePays,
              namespacePays,
              'libraire',
              'vente par pays'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespaceLibraire">
      <b-col cols="12">
        <h2 :class="showDetails.libraire ? 'rotate active' : 'no-rotate'">
          Vente par libraire
          <i
            class="fas fa-chevron-left"
            @click="toggleLibraire"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.libraire"
        :id="'liste_stats_' + namespaceLibraire"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableLibraire"
          :name="namespaceLibraire"
          :actions="getActions(namespaceLibraire)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.libraire"
          verbose-namespace="Vente par libraire"
          @row-click="
            openDetails(
              $event,
              namespaceLibraire,
              'libraire',
              'vente par libraire'
            )
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableLibraire,
              namespaceLibraire,
              'libraire',
              'vente par libraire'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespaceFactures">
      <b-col cols="12">
        <h2 :class="showDetails.factures ? 'rotate active' : 'no-rotate'">
          Factures
          <i
            class="fas fa-chevron-left"
            @click="toggleFactures"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.factures"
        :id="'liste_stats_' + namespaceFactures"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableFactures"
          :name="namespaceFactures"
          :actions="getActions(namespaceFactures)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.factures"
          verbose-namespace="Factures"
          @row-click="
            openDetails($event, namespaceFactures, 'libraire', 'factures')
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableFactures,
              namespaceFactures,
              'libraire',
              'factures'
            )
          "
        />
      </b-col>
    </div>

    <StatsModal :generic-table-namespace="namespaceTab" />
  </div>
</template>

<script>
import MixinStats from "@/mixins/mixinStats";

export default {
  name: "ListeStatsLibraires",
  mixins: [MixinStats],
  data() {
    return {
      refGenericTableLivre: "tabLivreLibraire",
      refGenericTablePays: "tabPaysLibraire",
      refGenericTableLibraire: "tabLibraireLibraire",
      refGenericTableFactures: "tabLibraireFactures",

      namespaceLivre: "ventes_livre",
      namespacePays: "ventes_pays",
      namespaceLibraire: "ventes_libraire",
      namespaceFactures: "factures",

      showDetails: {
        livre: false,
        pays: false,
        libraire: false,
        factures: false,
      },

      extraFilters: {
        livre: {
          type: "libraire",
          sous_type: "vente par livre",
        },
        pays: {
          type: "libraire",
          sous_type: "vente par pays",
        },
        libraire: {
          type: "libraire",
          sous_type: "vente par libraire",
        },
        factures: {
          type: "libraire",
          sous_type: "factures",
        },
      },
    };
  },
  methods: {
    /**
     * Affiche/masque le tableau des ventes par livre et définit le namespace du tableau de recherche.
     * @public
     */
    toggleLivre() {
      this.showDetails.livre = !this.showDetails.livre;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des ventes par pays et définit le namespace du tableau de recherche.
     * @public
     */
    togglePays() {
      this.showDetails.pays = !this.showDetails.pays;
      this.$store.commit("setNamespaceSearch", 1);
    },
    /**
     * Affiche/masque le tableau des ventes par libraire et définit le namespace du tableau de recherche.
     * @public
     */
    toggleLibraire() {
      this.showDetails.libraire = !this.showDetails.libraire;
      this.$store.commit("setNamespaceSearch", 2);
    },
    /**
     * Affiche/masque le tableau des stats de factures et définit le namespace du tableau de recherche.
     * @public
     */
    toggleFactures() {
      this.showDetails.factures = !this.showDetails.factures;
      this.$store.commit("setNamespaceSearch", 3);
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/style/_stats.scss";
</style>
